import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "p-8" }
const _hoisted_2 = { class: "flex gap-3 w-full" }
const _hoisted_3 = {
  key: 0,
  class: "text-white"
}

import { useDoc } from '@/composables/useDoc';
import { TEncoderHeader } from '@/store/modules/db-types';
import MeiHead from '@/store/modules/mei-modules/MeiHead';
import { TMeiTagFactoryArgs } from '@/store/modules/mei-modules/MeiTag';
import { onMounted, ref, watch } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'ChoosePrevious',
  setup(__props) {

const selectedHead = ref<MeiHead>();
const encoderHeaders = ref<TEncoderHeader[]>();

const heads = ref<MeiHead[]>();
onMounted(async () => {
    encoderHeaders.value = await MeiHead.getUserEncoderHeaders();
    
    
    heads.value = encoderHeaders.value?.map(eh => {
        delete eh.headerTag?.xmlId;
        delete eh.headerTag?.id
        return new MeiHead(eh.headerTag as TMeiTagFactoryArgs)
    })

})


async function updateDocHead(head: MeiHead) {
    await useDoc().initializeHead(head)
    useDoc().updateUI()
}

return (_ctx: any,_cache: any) => {
  const _component_va_select = _resolveComponent("va-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createTextVNode(" Set header from previous Files: ", -1)),
      _createVNode(_component_va_select, {
        color: "primary",
        class: "w-full",
        options: heads.value,
        modelValue: selectedHead.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((selectedHead).value = $event)),
          updateDocHead
        ],
        "text-by": op => 'fwe' + (op as MeiHead)?.getWorkTitle()
      }, {
        "option-content": _withCtx(({ option }) => [
          option
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString((option as MeiHead).getWorkTitle()) + " - " + _toDisplayString(), 1))
            : _createCommentVNode("", true)
        ]),
        content: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("You can choose one...", -1)
        ]))]),
        _: 1
      }, 8, ["options", "modelValue", "text-by"])
    ])
  ]))
}
}

})